import { render } from "./purchaseForm.vue?vue&type=template&id=b60376e2&scoped=true"
import script from "./purchaseForm.vue?vue&type=script&lang=js"
export * from "./purchaseForm.vue?vue&type=script&lang=js"

import "./purchaseForm.vue?vue&type=style&index=0&id=b60376e2&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60376e2"]])

export default __exports__